import React from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from '@useHistory/useHistoryCompat';
import { HdResolvedComponent } from '../../../routing/components/resolved-component/HdResolvedComponent';
import { useLogin } from '../../hooks/useLogin';

export function LoginWithCode() {
  const history = useHistory();
  const { code } = useParams<{ code: string }>();
  const { loginWithCode } = useLogin();

  const redirectResolver = () => {
    const searchParams = new URLSearchParams(history.location?.search);

    const next: string = searchParams.get('next');

    return loginWithCode(code, next).catch(() => {
      history.replace('/login');

      return null;
    });
  };

  return (
    <HdResolvedComponent
      Component={LoginWithCodeInner}
      resolve={{
        redirect: redirectResolver
      }}
    />
  );
}

function LoginWithCodeInner() {
  return <></>;
}
